import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { MultiUnitValidation } from 'uplisting-frontend/validations';

export default class MultiUnitRepositoryService extends BaseRepositoryService<
  ModelRegistry['multi-unit']
> {
  recordName = 'multi-unit';
  implementMethods = ['buildChangeset', 'findRecord', 'peekRecord'];

  validation = MultiUnitValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/multi-unit': MultiUnitRepositoryService;
  }
}
